import { render, staticRenderFns } from "./TeamLeaderboard.vue?vue&type=template&id=14b9b49c&lang=pug&"
import script from "./TeamLeaderboard.vue?vue&type=script&lang=js&"
export * from "./TeamLeaderboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports